/* ABRA Cookie */

(function() {
  'use strict';

  // Configuration
  const COOKIE_NAME = 'abra_affiliate';
  const COOKIE_DURATION_HOURS = 24; // 24 hours

  /**
   * Set a cookie
   */
  function setCookie(name) {
    const date = new Date();
    date.setTime(date.getTime() + (COOKIE_DURATION_HOURS * 60 * 60 * 1000));
    const expires = '; expires=' + date.toUTCString();
    document.cookie = name + '=1' + expires + '; path=/; SameSite=Lax';
  }

  /**
   * Get a cookie value
   */
  function getCookie(name) {
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');
    
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length);
      }
    }
    return null;
  }

  /**
   * Check URL for "abra" parameter
   */
  function getAbraParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('abralink');
  }

  /**
   * Initialize ABRA tracking
   */
  function init() {
    try {
      // Check if "abra" parameter exists in URL
      const abraValue = getAbraParameter();
      const existingCookie = getCookie(COOKIE_NAME);
      if (!existingCookie && abraValue) {
        setCookie(COOKIE_NAME);
      } else if (existingCookie) {
        document.querySelector('abra-popup')?.classList.add('hidden');
      }
    } catch (error) {
      // Fail silently
    }
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
